import { Component, AfterViewInit,Inject,ViewChild } from '@angular/core';
import {MatPaginator, MatSort} from '@angular/material';

import {MatDialog, MatDialogRef,MAT_DIALOG_DATA} from '@angular/material';
import {HttpClient} from '@angular/common/http';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { DataApiService } from 'src/app/Services/data-api.service';


@Component({
  selector: 'app-ver-usuarios',
  templateUrl: './ver-usuarios.component.html',
  styleUrls: ['./ver-usuarios.component.scss']
})
export class VerUsuariosComponent implements AfterViewInit {

  constructor(
    private http: HttpClient,   
        private dataApi:DataApiService,
 
  ) { }

  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  itemPerPage = 8;

  displayedColumns: string[] = [
    'id', 
    'name_surname',
    'nombre_empresa',
    'nombre_tipo_usuario',
    'principalOSecundario',
    'telefono',
    'email',
  ];
  
  public error = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngAfterViewInit() {
      this.exampleDatabase = new ExampleHttpDatabase(this.http,this.dataApi);
  
      // If the user changes the sort order, reset back to the first page.
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
      
      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isLoadingResults = true;
            return this.exampleDatabase!.getRepoIssues(
              this.sort.active, this.sort.direction, this.paginator.pageIndex);
          }),
          map(data => {
            // Flip flag to show that loading has finished.
            this.isLoadingResults = false;
            this.isRateLimitReached = false;
            this.resultsLength = data.total_count;
  
            return data.items;
          }),
          catchError(() => {
            this.isLoadingResults = false;
            // Catch if the GitHub API has reached its rate limit. Return empty data.
            this.isRateLimitReached = true;
            return observableOf([]);
          })
        ).subscribe(data => this.data = data);   
    }

}

export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  id:number,
  name:string,
  surname:string,
  area:string,
  email:string,
  telefono1:string,
  telefono2:string  
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase{
  constructor(private http: HttpClient,
    private dataApi : DataApiService) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<GithubApi> {     
    const href = this.dataApi.url;
    const requestUrl =`${href}/verUsuarios/${page + 1}/8`;

    return this.http.get<GithubApi>(requestUrl);
  }   
}
